import { useTranslations } from "src/apps/hooks/useTranslations";
import { useActorInvitationForm } from "src/apps/hooks/useActorInvitationForm";
import { useIsMedia } from "src/apps/hooks/useIsMedia";
import { T } from "src/apps/components/i18n/Translation";

import { Modal } from "@permisso/permisso-components";
import { ActorAccessEmailField } from "./ActorAccessEmailField";

const MODAL_TITLE = "documentation_area.actor_invitation.modal.title";
const MODAL_BODY = "documentation_area.actor_invitation.modal.body";
const EMAIL_TITLE = "common.email.title";
const EMAIL_PLACEHOLDER = "common.email.placeholder";
const EMAIL_INPUT_ID = "documentation-area-actor-invitation-email";
const SUBMIT_BUTTON_TEXT = "documentation_area.actor_invitation.modal.submit";

type ActorInvitationModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const ActorInvitationModal = ({ isOpen, onClose }: ActorInvitationModalProps) => {
  const { t } = useTranslations();
  const { isMobile } = useIsMedia();
  const { email, emailError, isPending, onEmailChange, resetAndClose, submit } =
    useActorInvitationForm(onClose);

  return (
    <Modal
      isOpen={isOpen}
      onClose={resetAndClose}
      title={<T k={MODAL_TITLE} />}
      description={<T k={MODAL_BODY} />}
      hasIcon={false}
      breakpoint={isMobile ? "mobile" : "desktop"}
      placement={isMobile ? "bottom" : "floating"}
      primaryActionLabel={<T k={SUBMIT_BUTTON_TEXT} />}
      onPrimaryAction={submit}
      isPrimaryActionDisabled={!email}
      isPrimaryActionLoading={isPending}
      secondaryActionLabel={<T k="common.cancel" />}
      onSecondaryAction={resetAndClose}
    >
      <ActorAccessEmailField
        id={EMAIL_INPUT_ID}
        email={email}
        label={<T k={EMAIL_TITLE} />}
        placeholder={t(EMAIL_PLACEHOLDER)}
        errorMessage={emailError ? <T k={emailError} /> : undefined}
        onEmailChange={onEmailChange}
      />
    </Modal>
  );
};
